import React from 'react';

const getInitialOnlineState = () => {
  if (typeof navigator === 'undefined') {
    return true;
  }
  if (typeof navigator.onLine === 'boolean') {
    return navigator.onLine;
  }
  return true;
};

export interface NetworkStatus {
  online: boolean;
  lastChangedAt: number;
}

export const useNetworkStatus = (): NetworkStatus => {
  const [status, setStatus] = React.useState<NetworkStatus>(() => ({
    online: getInitialOnlineState(),
    lastChangedAt: Date.now(),
  }));

  React.useEffect(() => {
    const handleChange = () => {
      setStatus({
        online: getInitialOnlineState(),
        lastChangedAt: Date.now(),
      });
    };

    window.addEventListener('online', handleChange);
    window.addEventListener('offline', handleChange);

    return () => {
      window.removeEventListener('online', handleChange);
      window.removeEventListener('offline', handleChange);
    };
  }, []);

  return status;
};
